module.exports = __webpack_public_path__ + "img/logo_econsenso.d6c47f2a.png";